import {AxiosResponse} from 'axios';
import {saveAs} from 'file-saver';
import {v4 as uuid} from 'uuid';
import contentStudioInstance from '@/utils/axiosContentStudio';

export const downloadFlowProcess = async (
  projectId: string,
  flowId: string,
  analyticsInteractionID: string,
  analyticsLocation: string,
  processEventHandlers: {
    started: (params: any) => void;
    ended: (params: any) => void;
  }
) => {
  const {started, ended} = processEventHandlers;
  const processID = uuid();

  const endpoint = `/api/v1/projects/${projectId}/download-output?flow_id=${flowId}`;
  started({
    endpoint,
    process_id: processID,
    process_name: 'download',
    original_id: flowId,
    interaction_id: analyticsInteractionID,
    asset_id: flowId,
    source: analyticsLocation,
  });

  let result = '';
  let errorMessage = '';

  try {
    const response = await contentStudioInstance.get(endpoint, {
      responseType: 'blob',
    });

    const filename = extractFilenameFromContentDisposition(response, 'assets');
    downloadFlow(response, filename);
    result = 'success';
    errorMessage = '';
  } catch (err) {
    result = 'failure';
    errorMessage = err instanceof Error ? err.message : String(err);
  } finally {
    ended({
      endpoint,
      outcome_id: flowId,
      original_id: flowId,
      result,
      process_id: processID,
      process_name: 'download',
      error: errorMessage,
    });
  }
};

export const downloadFlow = async (
  response: AxiosResponse,
  fileName: string
) => {
  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  });
  saveAs(blob, fileName);
};

export const extractFilenameFromContentDisposition = (
  response: AxiosResponse,
  defaultFilename: string
): string => {
  const contentDisposition = response.headers['content-disposition'] || '';
  const filename = parseContentDispositionFilename(contentDisposition);

  return filename || defaultFilename;
};

const parseContentDispositionFilename = (
  contentDisposition: string
): string | null => {
  if (!contentDisposition) return null;

  return (
    extractUnicodeFilename(contentDisposition) ||
    extractStandardFilename(contentDisposition)
  );
};

const extractUnicodeFilename = (contentDisposition: string): string | null => {
  const match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
  if (!match) return null;

  try {
    return decodeURIComponent(match[1]);
  } catch (error) {
    console.warn('Failed to decode Unicode filename:', error);
    return null;
  }
};

const extractStandardFilename = (contentDisposition: string): string | null => {
  const match = contentDisposition.match(/filename=([^;]+)/);
  if (!match) return null;

  return match[1].replace(/"/g, '');
};
